import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { HtmlText, formatText } from 'core/i18n';
import { URL_PATH_ES } from 'constants/multiLanguage';
import { LoadingSection } from 'commonsComponents/loadingSection';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import SnackBar from './components/components/snackBar';
import { getGenerateOtp, postVerifyOtp } from './helper/modalOtpUniversia.helper';
import { ModalComponent } from 'components/modal/modalComponent';

export const ModalOtpUniversia = ({ children, className, toggleSnackBar, userProfile, formActions }) => {
    const history = useHistory();
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [buttonValidation, setButtonValidation] = useState(true);
    const [errorCode, setErrorCode] = useState({});
    const [showErrorTexts, setShowErrorTexts] = useState(false);
    const [errorTexts, setErrorTexts] = useState({ title: '', description: '' });
    const [openModal, setopenModal] = useState(true);

    const passText = () => {
        setopenModal(false);
        history.push({
            pathname: URL_PATH_ES,
        });
    };
    const onConfirm = () => {
        postVerifyOtp({
            id,
            userProfile,
            setShowErrorTexts,
            setErrorCode,
            setErrorTexts,
            formActions,
            history,
            passText,
        });
    };
    const childrenWithProps = React.Children.map(children, child => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                setButtonValidation,
                passText,
                setErrorTexts,
                setShowErrorTexts,
                errorCode,
                errorTexts,
                showErrorTexts,
                setErrorCode,
            });
        }

        return child;
    });

    useEffect(() => {
        getGenerateOtp({ setLoading, id, passText, formActions });
    }, []);

    return (
        <ModalComponent
            isOpen={openModal}
            onCancel={passText}
            onConfirm={onConfirm}
            title={HtmlText(formatText('modalWelcome-title'))}
            cancelText={HtmlText(formatText('button-dontWant'))}
            confirmText={HtmlText(formatText('button-continue'))}
            isConfirmDisabled={buttonValidation}
            className={className}
        >
            <SnackBar toggleSnackBar={toggleSnackBar} />
            {loading ? <LoadingSection /> : childrenWithProps}
        </ModalComponent>
    );
};

ModalOtpUniversia.propTypes = {
    onConfirm: PropTypes.func,
    children: PropTypes.array,
    className: PropTypes.string,
    toggleSnackBar: PropTypes.bool,
    userProfile: PropTypes.object,
    formActions: PropTypes.object,
};
